// src/services/api/deliveryCharges.js
import { apiClient } from './base';

export const getDeliveryCharge = async (shopId, cityId) => {
  try {
    const response = await apiClient.get('/delivery-charges', {
      params: { shopId, cityId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllDeliveryCharges = async (shopId) => {
  try {
    const response = await apiClient.get('/delivery-charges/all', {
      params: { shopId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};